var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.thumbnail && _vm.imgLoaded)?_c('img',{attrs:{"src":_vm.thumbnail,"alt":_vm.name}}):(_vm.typeIcon)?_c('img',{class:_vm.typeCls,attrs:{"src":_vm.picUrl}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }